import React from 'react';

type FigureControlIcon = 'previous' | 'play' | 'pause' | 'next';

const ControlIcon: React.FC<{ type: FigureControlIcon }> = ({ type }) => {
  const paths: Record<FigureControlIcon, string> = {
    previous: 'm10.5 3.5-5 4.5 5 4.5z',
    play: 'M5 3.1 12.2 8 5 12.9z',
    pause: 'M4.25 3h2.5v10h-2.5zm5 0h2.5v10h-2.5z',
    next: 'm5.5 3.5 5 4.5-5 4.5z',
  };

  return (
    <svg viewBox="0 0 16 16" aria-hidden="true">
      <path d={paths[type]} />
    </svg>
  );
};

interface PlayButtonProps {
  playing: boolean;
  onClick: () => void;
  label?: string;
  className?: string;
}

export const BlogFigurePlayButton: React.FC<PlayButtonProps> = ({
  playing,
  onClick,
  label = 'animation',
  className = '',
}) => (
  <button
    type="button"
    className={`blog-figure-control blog-figure-control--play ${className}`.trim()}
    onClick={onClick}
    aria-label={`${playing ? 'Pause' : 'Play'} ${label}`}
    aria-pressed={playing}
    title={playing ? 'Pause' : 'Play'}
  >
    <ControlIcon type={playing ? 'pause' : 'play'} />
  </button>
);

interface BlogFigureControlsProps {
  playing: boolean;
  onPrevious: () => void;
  onToggle: () => void;
  onNext: () => void;
  previousDisabled?: boolean;
  nextDisabled?: boolean;
  label?: string;
  itemLabel?: string;
  className?: string;
}

const BlogFigureControls: React.FC<BlogFigureControlsProps> = ({
  playing,
  onPrevious,
  onToggle,
  onNext,
  previousDisabled = false,
  nextDisabled = false,
  label = 'Diagram playback controls',
  itemLabel = 'step',
  className = '',
}) => (
  <div className={`blog-figure-controls ${className}`.trim()} role="group" aria-label={label}>
    <button
      type="button"
      className="blog-figure-control"
      onClick={onPrevious}
      disabled={previousDisabled}
      aria-label={`Previous ${itemLabel}`}
      title={`Previous ${itemLabel}`}
    >
      <ControlIcon type="previous" />
    </button>
    <BlogFigurePlayButton playing={playing} onClick={onToggle} label={itemLabel} />
    <button
      type="button"
      className="blog-figure-control"
      onClick={onNext}
      disabled={nextDisabled}
      aria-label={`Next ${itemLabel}`}
      title={`Next ${itemLabel}`}
    >
      <ControlIcon type="next" />
    </button>
  </div>
);

export default BlogFigureControls;
